import React from 'react';

class PlayPause extends React.Component {
  render() {
    return <div className='b-play-pause b-playpause paused' onClick={this.props.onClick} onTouchEnd={this.props.onClick}></div>;
  }
}

export default PlayPause;
